import { skipToken } from '@reduxjs/toolkit/query';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import {
  useGetOrganizationApplicationByOrganizationApplicationIdQuery,
  useGetOrganizationApplicationDeviceMdmActionsQuery,
} from '@/redux/slices/organizationApiSlice';

export const useDeviceMdmActions = (
  mdmProviderId: string | undefined,
  deviceId: string | undefined
) => {
  const { byoMdmLockAndWipe } = useFlags();
  const organizationId = useGetOrganizationId();
  const shouldCheck = byoMdmLockAndWipe && !!mdmProviderId && !!deviceId;

  const {
    data: organizationApplication,
    isError: isOrganizationApplicationError,
  } = useGetOrganizationApplicationByOrganizationApplicationIdQuery(
    shouldCheck
      ? { organizationApplicationId: mdmProviderId, organizationId }
      : skipToken
  );

  const applicationKey = organizationApplication?.application.slug;

  const { data: mdmActions, isError: isMdmActionsError } =
    useGetOrganizationApplicationDeviceMdmActionsQuery(
      shouldCheck && applicationKey
        ? { organizationId, applicationKey, deviceId }
        : skipToken
    );

  if (!shouldCheck) {
    return { canLock: true, canWipe: true };
  }

  // If we can't confirm what the connected MDM supports, fail closed rather
  // than leaving lock/wipe stuck in the "checking support" state forever.
  if (isOrganizationApplicationError || isMdmActionsError) {
    return { canLock: false, canWipe: false };
  }

  return { canLock: mdmActions?.canLock, canWipe: mdmActions?.canWipe };
};
